module.exports = __webpack_public_path__ + "static/img/fynbus-logo-transparent-bg.22b345ef.png";